document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-techlume-product]').forEach((root) => {
    const media = [...root.querySelectorAll('[data-media-index]')];
    const thumbs = [...root.querySelectorAll('[data-thumb-index]')];
    let active = Math.max(0, media.findIndex((el) => el.classList.contains('is-active')));

    const showMedia = (index) => {
      if (!media.length) return;
      active = (index + media.length) % media.length;
      media.forEach((el, i) => {
        const on = i === active;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) el.querySelectorAll('video').forEach((v) => v.pause?.());
      });
      thumbs.forEach((el, i) => {
        const on = i === active;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) el.scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    };
    thumbs.forEach((btn, i) => btn.addEventListener('click', () => showMedia(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(active - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(active + 1));

    const stage = root.querySelector('.tl-pdp-stage');
    let touchX = null;
    stage?.addEventListener('touchstart', (e) => { touchX = e.touches[0]?.clientX ?? null; }, { passive: true });
    stage?.addEventListener('touchend', (e) => {
      if (touchX == null) return;
      const endX = e.changedTouches[0]?.clientX ?? touchX;
      const delta = endX - touchX;
      touchX = null;
      if (Math.abs(delta) > 45 && media.length > 1) showMedia(active + (delta < 0 ? 1 : -1));
    }, { passive: true });

    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    const qty = root.querySelector('[data-qty-input]');
    minus?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    plus?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) + 1); });

    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-pdp-price]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const sku = root.querySelector('[data-pdp-sku]');
    const add = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const mobileAdd = root.querySelector('[data-mobile-add]');
    const syncVariant = () => {
      if (!select) return;
      const o = select.options[select.selectedIndex];
      const available = o.dataset.available === 'true';
      const p = o.dataset.price || '';
      const c = o.dataset.compare || '';
      if (price) price.innerHTML = `<strong>${p}</strong>${c ? `<s>${c}</s>` : ''}`;
      if (mobilePrice) mobilePrice.textContent = p;
      if (sku) sku.textContent = o.dataset.sku ? `SKU: ${o.dataset.sku}` : '';
      if (add) add.disabled = !available;
      if (mobileAdd) { mobileAdd.disabled = !available; mobileAdd.textContent = available ? 'Į krepšelį' : 'Išparduota'; }
      if (addLabel) addLabel.textContent = available ? 'Į krepšelį' : 'Išparduota';
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', o.value);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}
    };
    select?.addEventListener('change', syncVariant);
    mobileAdd?.addEventListener('click', () => add?.click());
  });
});
